<template>
  <div>
    <TopNav />
    <div class="main-content">
      <div class="container mt-5">
        <div class="row pt-5">
          <div class="col-12 col-lg-12">
            <div v-if="message" class="col-12 alert alert-primary text-center">{{ message }}</div>
            <ul v-else class="nav nav-tabs justify-content-center mb-4">
              <li class="nav-item">
                <a href="javascript:;" class="nav-link" @click="tab = 'examBased'" :class="tab=='examBased' ? 'active' : ''">Sınav Bazlı Rapor</a>
              </li>
              <li class="nav-item">
                <a href="javascript:;" class="nav-link" @click="tab = 'lessonBased'" :class="tab=='lessonBased' ? 'active' : ''">Ders Bazlı Rapor</a>
              </li>
              <li class="nav-item">
                <a href="javascript:;" class="nav-link" @click="tab = 'earningBased'" :class="tab=='earningBased' ? 'active' : ''">Kazanım Bazlı Rapor</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row" v-if="tab=='examBased'">
          <div class="col-12" :key="e.ids" v-for="(e, index) in examBasedReportData">
            <div class="card lift">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col">
                    <h4 class="mb-2"><a href="javascript:;">{{ e.sinav_adi }}</a></h4>
                    <p class="small text-muted mb-0"> {{ e.baslama_tarihi }} </p>
                    <div class="row align-items-center no-gutters">
                      <div class="col-auto">
                        <div class="small mr-2" :class="percentageColor(e.lessons[0]['result']['YUZDE'])">Başarı Puanın: {{ e.lessons[0]['result']['YUZDE'] }}%</div>
                      </div>
                      <div class="col">
                        <div class="progress progress-sm">
                          <div class="progress-bar" :class="percentageColor(e.lessons[0]['result']['YUZDE'], 'progressbar')" role="progressbar" :style="{width: e.lessons[0]['result']['YUZDE']+'%' }" :aria-valuenow="e.lessons[0]['result']['YUZDE']" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                    </div>
                    <span :key="index2" v-for="(d, index2) in e.lessons">
                      <a class="badge mr-2" v-if="d.result.YUZDE !== null" :class="activeExamNLesson == index+index2 ? percentageColor(d.result.YUZDE, 'badge') + ' active' : percentageColor(d.result.YUZDE, 'badge')" @click="activeExamNLesson == index+index2 ? activeExamNLesson = null : activeExamNLesson = index+index2" href="javascript:;">{{ d.lesson_name }}</a> 
                    </span>
                    <span :key="'_'+i" v-for="(lesson_detail, i) in e.lessons">
                      <div class="list-group list-group-flush" v-if="activeExamNLesson == index+i && lesson_detail.result.YUZDE !== null">
                        <span :key="i2" v-for="(num, i2) in lesson_detail.result">
                          <div class="list-group-item" v-if="i2 != 'YUZDE'">
                            <div class="row align-items-center">
                              <div class="col">
                                <small :class="resultKeyToClass(i2)">• {{ resultKeyToTitle(i2) }}</small>
                              </div>
                              <div class="col-auto">
                                <span class="small" :class="resultKeyToClass(i2)">
                                  {{ num == null ? '-' : num }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </span>
                        <div class="row align-items-center no-gutters">
                          <div class="col-auto">
                            <div class="small mr-2" :class="percentageColor(lesson_detail.result.YUZDE)">Başarı Yüzden: {{ lesson_detail.result.YUZDE }}%</div>
                          </div>
                          <div class="col">
                            <div class="progress progress-sm">
                              <div class="progress-bar" :class="percentageColor(lesson_detail.result.YUZDE, 'progressbar')" role="progressbar" :style="{width: lesson_detail.result.YUZDE+'%' }" :aria-valuenow="lesson_detail.result.YUZDE" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="tab=='lessonBased'">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="btn-group">
                  <a href="javascript:;" @click="activeLessonTable = ind" :class="activeLessonTable == ind ? 'btn-primary' : 'btn-white'"  class="btn btn-sm" :key="ind" v-for="(l_name, ind) in lessons">
                    {{ l_name }}
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-0" :key="ind" v-for="(l_name, ind) in lessons">
                <table class="table table-sm table-nowrap card-table" v-if="ind == activeLessonTable">
                  <thead>
                    <tr>
                      <th>
                        Sınav
                      </th>
                      <th>
                        Soru Sayısı
                      </th>
                      <th>
                        Doğru Sayısı
                      </th>
                      <th>
                        Yanlış Sayısı
                      </th>
                      <th>
                        Boş Sayısı
                      </th>
                      <th>
                        Net
                      </th>
                      <th>
                        Başarı Yüzdesi
                      </th>
                    </tr>
                  </thead>
                  <tbody :key="k" v-for="(data, k) in examBasedReportData">
                    <tr class="lift" v-if="data.lessons[ind].result.SS !== null" :class="data.sinav_adi == 'TOPLAMLAR' ? 'font-weight-bold' : ''">
                      <td>
                        <span>{{ data.sinav_adi }}</span>
                      </td>
                      <td>
                        {{ data.lessons[ind].result.SS }}
                      </td>
                      <td>
                        {{ data.lessons[ind].result.DS }}
                      </td>
                      <td>
                        {{ data.lessons[ind].result.YS }}
                      </td>
                      <td>
                        {{ data.lessons[ind].result.BS }}
                      </td>
                      <td>
                        {{ data.lessons[ind].result.NET }}
                      </td>
                      <td>
                        <div class="row align-items-center no-gutters">
                          <div class="col-auto">
                            <span class="mr-2">{{ data.lessons[ind].result.YUZDE }}%</span>
                          </div>
                          <div class="col">
                            <div class="progress progress-sm">
                              <div class="progress-bar bg-secondary" role="progressbar" :style="{ width: data.lessons[ind].result.YUZDE+'%' }" :aria-valuenow="data.lessons[ind].result.YUZDE" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="tab=='earningBased'">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="btn-group">
                  <a href="javascript:;" @click="activeLessonTable = ind" :class="activeLessonTable == ind ? 'btn-primary' : 'btn-white'"  class="btn btn-sm" :key="ind" v-for="(l_name, ind) in lessons">
                    {{ l_name }}
                  </a>
                </div>
              </div>
              <div class="table-responsive mb-0" :key="ind" v-for="(l_name, ind) in lessons">
                <table class="table table-sm table-nowrap card-table" v-if="ind == activeLessonTable">
                  <thead>
                    <tr>
                      <th>
                        Sınıf
                      </th>
                      <th>
                        Branş
                      </th>
                      <th>
                        Alt Konu
                      </th>
                      <th>
                        Soru Sayısı
                      </th>
                      <th>
                        Doğru Sayısı
                      </th>
                      <th>
                        Doğru Yüzdesi
                      </th>
                    </tr>
                  </thead>
                  <tbody :key="k" v-for="(data, k) in earningBasedReportData[ind]">
                    <tr class="lift">
                      <td>
                        <span>{{ data.SINIF }}. SINIF</span>
                      </td>
                       <td>
                        <span>{{ data.BRANS }}</span>
                      </td>
                      <td>
                        {{ data.ALTKONU }}
                      </td>
                      <td>
                        {{ data.SORU_SAYISI }}
                      </td>
                      <td>
                        {{ data.DOGRU_SAYISI }}
                      </td>
                      <td>
                        <div class="row align-items-center no-gutters">
                          <div class="col-auto">
                            <span class="mr-2">{{ data.DOGRU_YUZDESI }}%</span>
                          </div>
                          <div class="col">
                            <div class="progress progress-sm">
                              <div class="progress-bar bg-secondary" role="progressbar" :style="{ width: data.DOGRU_YUZDESI+'%' }" :aria-valuenow="data.DOGRU_YUZDESI" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav'
import base from '@/mixins/base'
import http from '@/helpers/http'

export default {
  name: 'Report',
  components: { TopNav },
  mixins: [ base ],
  data () {
    return {
      studentID: this.$store.state.auth.student_id,
      earningBasedReportData: {},
      examBasedReportData: null,
      tab: 'examBased',
      message: 'Yükleniyor...',
      activeExamNLesson: null,
      lessons: [],
      activeLessonTable: 0
    }
  },
  methods: {
    test(q) {
      console.log(q)
    },
    resultKeyToTitle(key) {

      switch (key) {
        case 'SS':
          key = 'Soru Sayısı'
          break;

        case 'DS':
          key = 'Doğru Sayısı'
          break;

        case 'YS':
          key = 'Yanlış Sayısı'
          break;

        case 'BS':
          key = 'Boş Sayısı'
          break;

        case 'NET':
          key = 'Net'
          break;
      
        default:
          break;
      }
      return key;
    },
    resultKeyToClass(key) {

      switch (key) {
        case 'SS':
          key = 'text-dark'
          break;

        case 'DS':
          key = 'text-success'
          break;

        case 'YS':
          key = 'text-danger'
          break;

        case 'BS':
          key = 'text-muted'
          break;

        case 'NET':
          key = 'text-primary'
          break;
      
        default:
          break;
      }
      return key;
    },
    percentageColor(percentage, type = 'text') {

      if (percentage <= 25) {
        percentage = 'danger'
      } else  if (percentage <= 50) {
        percentage = 'warning'
      } else  if (percentage <= 75) {
        percentage = 'primary'
      } else {
        percentage = 'success'
      }

      percentage = 'primary' // temporary bro :)
      if (type == 'progressbar') {
        percentage = 'bg-' + percentage
      } else if (type == 'badge') {
        percentage = 'badge-' + percentage
      } else {
        percentage = 'text-' + percentage
      }
      return percentage
    },
    fetchEarningData(lessonID) {
      http.post('ev-calismasi-rapor2', {
      ogrenciID: this.studentID,
      dersID: lessonID
    }).then(response => {
      if (typeof response.data === 'object') {
        if (this.activeLessonTable === 0 &&  Object.keys(this.earningBasedReportData).length === 0) {
          this.activeLessonTable = lessonID
        }
        this.earningBasedReportData[lessonID] = response.data
        this.message = '';
      }
    }).catch(error => {
      throw error;
    });
    }
  },
  created() {
    // examBasedReportData
    http.post('ev-calismasi-rapor1', {
      ogrenciID: this.studentID,
      dersID: 'all'
    }).then(response => {
      if (typeof response.data == 'object') {
        let reData = {}
        let lessons = {}
        response.data.forEach((exam, index) => { // eslint-disable-line
          if (typeof reData[index] === 'undefined') {
            reData[index] = {"lessons": {}}
          }      
          for (var detail in exam) {
            
            if (detail.indexOf('_') !== -1 && !isNaN(detail.split("_")[0])) { // main lesson id

              let key = detail.split("_")[0]
              if (typeof lessons[key] === 'undefined') lessons[key] = exam[key];

              if (typeof reData[index]['lessons'][key]['result'] === 'undefined') reData[index]['lessons'][key]['result'] = {}
              reData[index]['lessons'][key]['result'][detail.split("_")[1]] = exam[detail]

            } else if(detail.indexOf('_') !== -1 && isNaN(detail.split("_")[0])) { // lesson detail
              
              if (detail.split("_")[0] === 'GENEL') {

                if (typeof reData[index]['lessons'][0] === 'undefined') {
                  reData[index]['lessons'][0] = {"result": {}, "lesson_name" : 'GENEL'}
                }
                if (typeof reData[index]['lessons'][0]['result'] === 'undefined') reData[index]['lessons'][0]['result'] = {}
                reData[index]['lessons'][0]['result'][detail.split("_")[1]] = exam[detail]

              } else { // other main index details
                reData[index][detail] = exam[detail]
              }

            } else {

              if (typeof reData[index][detail] === 'undefined') {
                if (detail == 'ids') {
                  reData[index][detail] = exam[detail]
                }
                else {
                  reData[index]['lessons'][detail] = {"result": {}, "lesson_name" : exam[detail]}
                }
              }
            }
          }
        });
        this.lessons = lessons
        Object.keys(this.lessons).forEach(lessonID => {
          this.fetchEarningData(lessonID)
        });
        this.examBasedReportData = reData
        this.message = '';
      } else {
        this.examBasedReportData = null
        this.message = 'Veri alınamadı!';
      }
    }).catch(error => {
      throw error;
    });
  }
}
</script>
<style scoped>
@media (max-width: 768px) { 
  .card-header a.btn.btn-sm {
    font-size: 8px;
  }
}
</style>